// extracted by mini-css-extract-plugin
export default {"AccessibilityStatementIcon":"AccessibilityStatement_AccessibilityStatementIcon__y4Hg3"};